import styled from "styled-components";

export const ContainerSideBar = styled.div`
  width: 314px;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding-top: 40px;
`;

export const Container = styled.div`
  width: 265px;
`;

export const Title = styled.button`
  width: 265px;
  height: 48px;
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.02),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.03),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.04),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.04),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.05),
    0px 100px 80px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  padding-left: 16px;
  background-color: ${({ $titleSelected }) =>
    $titleSelected ? "var(--color-latex10)" : "var(--color-white)"};
  color: ${({ $titleSelected }) =>
    $titleSelected ? "var(--color-white)" : ""};
  display: flex;
  justify-content: space-between;
  gap: 20px;
  ${({ $titleActive }) =>
    $titleActive
      ? "border-top-right-radius: 24px; border-top-left-radius: 24px;"
      : "border-radius:24px;"}

  h1 {
    padding: 0;
    margin: 0;
    padding-left: 10px;
    font-size: 24px;
    font-weight: bold;
  }
  .container-arrow {
    padding-right: 20px;
    svg {
      transform: ${({ $titleActive }) =>
        $titleActive ? "rotate(-90deg)" : "rotate(0deg)"};
      transition: 200ms;
    }
  }
  cursor: pointer;
`;

export const ContainerContent = styled.div`
  background-color: var(--color-white);
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.02),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.03),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.04),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.04),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.05),
    0px 100px 80px 0px rgba(0, 0, 0, 0.07);
  ${({ $titleActive }) =>
    $titleActive
      ? "max-height: 600px;padding-bottom: 20px;border-bottom-right-radius: 24px;border-bottom-left-radius: 24px;"
      : "max-height: 0; overflow: hidden;"}
`;

export const ContainerItem = styled.div`
  width: 100%;
  background-color: var(--color-white);
  display: flex;
  gap: 18px;
  padding-left: 20px;
  align-items: center;
  height: 36px;
  position: relative;
  transition: background-color 0.1s ease-out; /* Transición para el cambio de fondo */
  h1 {
    margin: 0;
    padding: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
  }
  &:hover {
    ${({ $itemActive }) =>
      $itemActive ? "" : "background-color: var(--color-grey85);"}
  }
  cursor: pointer;

  .flecha-option {
    content: "";
    ${({ $itemActive }) => {
      if ($itemActive) {
        return `
        position: absolute;
         right:-10px;
         z-index: 100;
        width: 20px; 
      height: 20px; 
      border: 3px solid var(--color-resaltado); 
      background: var(--color-resaltado);
      transform: rotate(45deg) skew(15deg, 15deg);
      `;
      }
    }}
  }
  .iconSidebar {
    width: 20px;
  }

  ${({ $itemActive }) => {
    return $itemActive
      ? "background-color: var(--color-latex10);color:var(--color-white);svg{ filter: brightness(0) invert(1);}}"
      : "";
  }}
`;
